import { useWorkspaceTree } from "../Stores/WorkspaceTree";

export {
    WORKSPACE_FILTER_UNMAPPED_ID,
    filterSpaceCategoriesByWorkspaceFilter,
    normalizeWorkspaceFilterIds,
    resolveWorkspaceCategoryIdForSelection,
    shouldClearWorkSelectionForWorkspaceFilter,
    workspaceFilterIncludesUnmapped,
    withUnmappedExcludedFromWorkspaceFilter,
    withUnmappedIncludedInWorkspaceFilter,
} from "./workspaceFilterSelection";

/**
 * Resolve the Space Group's division id for a workspace (space) id.
 */
export function resolveDivisionIdFromSpaceId(spaceId) {
    if (!spaceId) {
        return null;
    }

    const tree = useWorkspaceTree();
    const space = tree.getWorkspaceById(spaceId);
    const categoryId =
        space?.workspaceCategoryId ?? space?.workspace_category_id;

    return resolveDivisionIdFromSpaceGroupId(categoryId);
}

/**
 * Resolve the division id for a Space Group (workspace category) id.
 */
export function resolveDivisionIdFromSpaceGroupId(workspaceCategoryId) {
    if (!workspaceCategoryId) {
        return null;
    }

    const category = useWorkspaceTree().getWorkspaceCategoryById(
        workspaceCategoryId,
    );
    const divisionId = Number(category?.division_id);

    return Number.isFinite(divisionId) && divisionId > 0 ? divisionId : null;
}

/**
 * Resolve the Space Group division id associated with a work-entity conversation.
 */
export function resolveDivisionIdForConversation(conversation) {
    if (!conversation) {
        return null;
    }

    const tree = useWorkspaceTree();
    const typeId =
        conversation.type_id ??
        conversation.originalData?.type_id ??
        conversation.resourceId;

    if (conversation.is_space_group) {
        return resolveDivisionIdFromSpaceGroupId(typeId);
    }

    if (conversation.is_space) {
        return resolveDivisionIdFromSpaceId(typeId);
    }

    if (conversation.is_board_group) {
        const group = tree.getBoardCategoryById(typeId);
        return resolveDivisionIdFromSpaceId(
            group?.workspaceId ?? group?.workspace_id,
        );
    }

    if (conversation.is_board) {
        const board = tree.getBoardById(typeId);
        return resolveDivisionIdFromSpaceId(
            board?.workspaceId ?? board?.workspace_id,
        );
    }

    if (conversation.is_item_group) {
        const group = tree.getItemCategoryById(typeId);
        return resolveDivisionIdFromSpaceId(
            group?.workspaceId ?? group?.workspace_id,
        );
    }

    if (conversation.is_item) {
        const item = tree.getItemById(typeId);
        const spaceId =
            conversation.space_id ??
            conversation.spaceId ??
            item?.workspaceId ??
            item?.workspace_id;
        return resolveDivisionIdFromSpaceId(spaceId);
    }

    const fallbackSpaceId = conversation.space_id ?? conversation.spaceId;

    return resolveDivisionIdFromSpaceId(fallbackSpaceId);
}

